var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"slice-vimeo-youtube-player w-full md_px-20 my-100"},[_c('div',{staticClass:"lg_w-8x12 mx-auto md_px-20"},[_c('div',{staticClass:"md_w-full_80 md_-ml-40"},[_c('video-plyr-js',{attrs:{"embed":_vm.slice.vimeoYoutubeEmbed,"video":_vm.slice.videoAsset && _vm.slice.videoAsset[0]}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }